import { useTranslation } from 'react-i18next';
import { IMG_PATH, TRAIL_URL } from 'constants/config';

const backgroundImage = `url(${IMG_PATH}/bg.png)`;

const green = '#bbeb98';

/**
 * 開頭圖片文字
 */
function MainHeader() {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      {/* 搶先試用 */}
      <div
        className="relative flex flex-col items-center text-white bg-cover h-[575px] sm:h-[717px]"
        style={{ backgroundImage }}
      >
        <div
          className="absolute top-0 w-full h-full"
          style={{ backgroundColor: 'rgba(73, 56, 49, 0.6)' }}
        />
        <div className="absolute top-0 w-full h-full flex flex-col items-center pt-12">
          <div className="text-4xl mb-16">
            邁向 <span className="text-apricot">財務自由</span> 之路
          </div>

          <div className="text-xl">好的策略帶你上天堂</div>
          <div className="text-xl" style={{ color: green }}>
            嚴選投資顧問
          </div>
          <div className="text-xl">和你一同紀律執行，達到財務自由</div>

          <a
            href={TRAIL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-60 h-14 text-2xl bg-turquoise flex flex-center rounded mt-auto"
            style={{ boxShadow: '0px 8px 0px 0px #30a098' }}
          >
            搶先試用
          </a>

          <div className="w-20 h-20">
            <img src={`${IMG_PATH}/calm-arrow.gif`} alt="" />
          </div>

          <div className="mt-auto mx-12">
            <img src={`${IMG_PATH}/stock.png`} alt="" />
          </div>
        </div>
      </div>

      {/* 與我聯繫 */}
      <div className="flex flex-col justify-between items-center bg-blue-light h-56 py-12">
        <div className="text-xl text-gray-dark">{t('Main.Suggestion')}</div>

        <button className="w-48 h-14 text-xl border-2 border-blue rounded-full text-blue">
          {t('Main.ContactMe')}
        </button>
      </div>
    </div>
  );
}

export default MainHeader;
